export function formatPhone(phone: string) {
    if (phone.length == 12) {
        // Format suisse commençant par +
        return phone.slice(0, 3) + ' ' + phone.slice(3, 5) + ' ' + phone.slice(5, 8) + ' ' + phone.slice(8, 10) + ' ' + phone.slice(10, 12)
    } else if (phone.length == 11 && phone[0] != '+') {
        // Format suisse sans le +
        return '+' + phone.slice(0, 2) + ' ' + phone.slice(2, 4) + ' ' + phone.slice(4, 7) + ' ' + phone.slice(7, 9) + ' ' + phone.slice(9, 11)
    }
    return phone;
}